import { Pipe, PipeTransform, inject } from '@angular/core';
import { NumberService } from '../services/number.service';

@Pipe({
  name: 'currencyFormat',
})
export class CurrencyFormatPipe implements PipeTransform {
  private numberService = inject(NumberService);
  transform(value: number): string {
    const formatNumber = this.numberService.formatCurrency(value);
    return formatNumber;
  }
}
